module.exports = "/_next/static/files/b33b1a7315a283b242e110e9976d91a3.svg";